import React from 'react';
import { ExhibitHallViewInfo } from '@/types';
import { VStack, Text } from '@design-system/pc';
import styled from 'styled-components';

interface IntroContentProps {
  data?: ExhibitHallViewInfo;
}

const IntroContent = ({ data }: IntroContentProps) => {
  return (
    <>
      {(data?.intro.tel || data?.intro.description) && (
        <Container alignment="start">
          {data?.intro.tel && (
            <Text variant="headline6" color="color_chip.gray.700">
              전화번호 {data?.intro.tel}
            </Text>
          )}
          {data?.intro.description && (
            <Text variant="body1" color="color_chip.gray.700">
              {data?.intro.description}
            </Text>
          )}
        </Container>
      )}
    </>
  );
};

export default IntroContent;

const Container = styled(VStack)`
  gap: 8px;
  margin-bottom: 80px;
`;
